import { useCallback } from "react";
import { useSearchParams } from "react-router";

export const useBankImportParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const bankConnectionId = Number(searchParams.get("bankConnectionId"));
  const flow = searchParams.get("flow");
  const isEarlyRedirect = searchParams.get("isEarlyRedirect") === "true";

  const clearParams = useCallback(() => {
    setSearchParams((prev) => {
      prev.delete("bankConnectionId");
      prev.delete("bankConnectionType");
      prev.delete("flow");
      prev.delete("isEarlyRedirect");
      return prev;
    });
  }, [setSearchParams]);

  return {
    bankConnectionId: bankConnectionId > 0 ? bankConnectionId : null,
    flow,
    isEarlyRedirect,
    clearParams,
  };
};
